/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Table, Empty, Popconfirm, message } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { Query, graphql } from 'react-apollo'
import gql from 'graphql-tag'
import { RoleCode } from '../../../constants'

import AddForm from './addForm'
import ViewDetails from './view'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			page: 1,
			pageSize: 10,
			searchText: '',
			sortOrder: null,
			sortName: null,
			isAddFormShown: false,
			isViewDetailShown: false,
			isEdit: false,
			selectedProject: null
		}
        
		this.handleOnChange = this.handleOnChange.bind(this)
	}
    
	handleOnChange(pagination, filters, sorter) {
		this.setState({
			page: pagination.current,
			pageSize: pagination.pageSize,
			sortOrder: (sorter.order === 'ascend') ? 'asc' : 'desc',
			sortName: sorter.field,
			// reservation_status: filters.status,
		})
	}

	render() {
		const { AuthStore } = this.props
		const { barangay_uid, user_type } = AuthStore
		const { page, pageSize, sortOrder, sortName, searchText,
			isAddFormShown, isEdit, selectedProject, isViewDetailShown
		} = this.state
		const filters = { 
			page, pageSize, searchText, sortOrder, sortName
		}
		const isAdmin = (_.isEqual(user_type, RoleCode.SYSTEMADMIN) || _.isEqual(user_type, RoleCode.SUPERADMIN))
		
		return (
			<React.Fragment>
				<div className="row">
					<div className="col-12">
						<div className="page-title-box">
							<div className="page-title-right">
								<ol className="breadcrumb m-0">
									<li className="breadcrumb-item"><Link to='/'>Dashboard</Link></li>
									<li className="breadcrumb-item"><a href='javascript:void(0)'>Barangay Management</a></li>
									<li className="breadcrumb-item active">Projects</li>
								</ol>
							</div>
							<h4 className="page-title">Projects</h4>
						</div>
					</div>
				</div>
				<div className="row" style={{ minHeight: '600px' }}>
					<div className="col-12">
						<div className='card'>
							<div className='card-body'>
								<Row>
									<button type="button" className="btn btn-primary btn-rounded waves-effect waves-light" onClick={() => {
										this.setState({ isAddFormShown: true, isEdit: false, selectedProject: null })
									}} style={{ float: 'right' }}>Add New</button>
									<Input placeholder='Search Here' style={{ width: 230, float: 'right', marginRight: 20, marginTop: 5 }} onChange={(e) => {
										this.setState({ searchText: e.target.value })
									}}/>
								</Row>
								<br />
								<Row>
									<Query query={BARANGAY_PROJECTS} variables={{ searchFilter: filters, barangay_uid }}>
										{({ loading, error, data }) => {
											if (error) return <Empty/>

											let allProjects = _.has(data,'allProjects') ? data.allProjects.data : []
											allProjects = allProjects.map((allProject, key) => Object.assign({}, allProject, { key }))
											let _pagination = _.has(data, 'allProjects') ? data.allProjects.pagination : {}
											_pagination = Object.assign({}, _pagination, {
												pageSizeOptions: ['10', '25', '50'],
												showSizeChanger: true,
												total: _.has(_pagination, 'rowCount') ? _pagination.rowCount : 0,
												showTotal: (total) => `Total ${total} items`
											})

											const columns = [
												{
													title: 'Project',
													dataIndex: 'project_name',
													key: 'project_name',
												//width: 300
												}, {
													title: 'Description',
													dataIndex: 'project_description',
													key: 'project_description'
												}, {
													title: 'Remarks',
													dataIndex: 'remarks',
													key: 'remarks'
												}, {
													title: 'Start At',
													key: 'date_start',
													render: (record) => (
														<span>{moment(record.date_start).format('ll')}</span>
													)
												}, {
													title: 'End At',
													key: 'date_end',
													render: (record) => (
														<span>{
															moment(record.date_end).isValid() ?
																moment(record.date_end).format('ll') : '- - -'
														}</span>
													)
												}, {
													title: 'Action',
													key: 'action',
													render: (record) => {
														return (
															<React.Fragment>
																<a 
																	style={{ marginRight: 10 }}
																	href="#" 
																	onClick={() => this.setState({ isViewDetailShown: true, selectedProject: record })}
																>View</a>
																{
																	isAdmin &&
																	<a href="#" style={{ marginRight: 10 }} onClick={() => this.setState({ isAddFormShown: true, isEdit: true, selectedProject: record })}>Edit</a>
																}
																{
																	isAdmin &&
																	<Popconfirm
																		title="Are you sure delete this Project?"
																		onConfirm={() => {
																			const { deleteProject } = this.props
																			deleteProject({ project_uid: record.uid })
																				.then((response) => {
																					message.success('Project successfully deleted.')

																					//create audit trail
																					const auditParams = {
																						module_name: 'Project',
																						action: 'Delete',
																						message: `Deleted project ${record.project_name}`
																					}
																					AuthStore.saveAuditTrail(auditParams)
																				}).catch(err => {
																					console.log('error deleting complain', err)
																					message.error(err.message.replace('GraphQL error:', ''))
																				})
																		}}
																		// onCancel={cancel}
																		okText="Yes"
																		cancelText="No"
																	>
																		<a href="javascript:void(0)" >Delete</a>
																	</Popconfirm>
																}
															</React.Fragment>
														)
													}
												}]
											return (
												<Table 
													loading={loading}
													columns={columns} 
													dataSource={allProjects} 
													bordered
													onChange={this.handleOnChange}
													pagination={_pagination}
													scroll={{ x: 1020 }}
												/>
											)
										}}
									</Query>
								</Row>
							</div>
						</div>
					</div>
				</div>
				{
					isAddFormShown &&
					<AddForm
						isEdit={isEdit}
						selectedProject={selectedProject}
						visible={isAddFormShown}
						onClose={() => this.setState({ isAddFormShown: false, isEdit: false, selectedProject: null })}
					/>
				}
				{
					isViewDetailShown &&
					<ViewDetails 
						project={selectedProject}
						visible={isViewDetailShown}
						onCancel={() => this.setState({ isViewDetailShown: false, selectedProject: null })}
					/>
				}
			</React.Fragment>
		)
	}
}

const BARANGAY_PROJECTS = gql`
    query allProjects($barangay_uid: String, $searchFilter: SearchParams) {
		allProjects(barangay_uid: $barangay_uid, searchFilter: $searchFilter)
    }
`

const DELETE_PROJECT = gql`
    mutation deleteProject($input: JSON) {
		deleteProject(input: $input)
    }
`

const composed = compose(
	inject('AuthStore'),
	graphql(DELETE_PROJECT, {
		props({ mutate }) {
			return {
				deleteProject(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['allProjects']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
